<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/partners/${this.$route.params.id}/discount-cards/${this.$route.params.discount_card_id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/partners/${this.$route.params.id}/discount-cards/${this.$route.params.discount_card_id}/edit`,
                    },
                    {
                        title: 'Клиенты',
                        url: `/partners/${this.$route.params.id}/discount-cards/${this.$route.params.discount_card_id}/clients`,
                    },
                    {
                        title: 'Импорт',
                        url: `/partners/${this.$route.params.id}/discount-cards/${this.$route.params.discount_card_id}/import`,
                    },
                ],
            };
        },
    };
</script>
